import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#0057a2",
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#e54448",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        black: "#000000",
        green: "#70C893",
        purple: "#5205B5",
        yellow: "#fec107"
      }
    }
  },
  lang: {
    locales: { es },
    current: "es"
  }
});
